module.exports = __webpack_public_path__ + "img/text-card.705ad9f7.svg";